import request from '../request';

const getBooks = () =>
    request
        .get(`/book`)
        .then((res) => res.json())
        .then((res) => res.docs);

export default getBooks;
